import React from "react";
import { Helmet } from "react-helmet";
import { Typography } from "@mui/material";
import Footer from "../Components/Footer";
import { LegalLayout, Section, Paragraph, BulletList, LegalPageLink } from "../Components/Legal/LegalLayout";

export default function CookiePolicy() {
  return (
    <div>
      <Helmet>
        <title>Cookie Policy | GroHair & GloSkin Dindigul</title>
        <meta
          name="description"
          content="Learn how GroHair & GloSkin Dindigul uses cookies and similar tracking technologies, and how you can manage your preferences."
        />
        <meta property="og:title" content="Cookie Policy | GroHair & GloSkin Dindigul" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://adgrohairgloskindindigul.in/cookie-policy" />
      </Helmet>

      <LegalLayout
        title="Cookie Policy"
        lastUpdated="August 28, 2026"
        intro={
          <>
            This Cookie Policy explains what cookies are, how Advanced GroHair & GloSkin – Dindigul
            ("We", "Us", "Our") uses them on{" "}
            <a href="https://adgrohairgloskindindigul.in/" style={{ color: "#e3242b" }}>
              https://adgrohairgloskindindigul.in/
            </a>{" "}
            (the "Website"), and the choices available to you. It should be read alongside Our{" "}
            <LegalPageLink to="/privacy-policy">Privacy Policy</LegalPageLink>.
          </>
        }
      >
        <Section heading="What Are Cookies?">
          <Paragraph>
            Cookies are small text files that are placed on Your computer or mobile device when You
            visit a website. They are widely used to make websites work, or work more efficiently,
            as well as to provide information to the owners of the site. Similar technologies, such
            as web beacons and pixel tags, may be used for the same purposes.
          </Paragraph>
          <Paragraph>
            Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your
            device after You close Your browser until they expire or You delete them. Session
            Cookies are deleted as soon as You close Your web browser.
          </Paragraph>
        </Section>

        <Section heading="How We Use Cookies">
          <Paragraph>
            When You first visit Our Website, a cookie consent banner is shown asking You to Accept,
            Reject, or Customize the cookies used on the Website. Non-essential cookies are only set
            after You give Your consent. You can change Your preference at any time by clearing Your
            browser's cookies for this site, which will show the banner again on Your next visit.
          </Paragraph>
          <Paragraph>We use the following categories of cookies:</Paragraph>

          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            Necessary / Essential Cookies
          </Typography>
          <Paragraph>
            <em>Type:</em> Session Cookies &nbsp;•&nbsp; <em>Administered by:</em> Us
            <br />
            These Cookies are essential to provide You with services available through the Website
            and to enable You to use some of its features. They help authenticate users and prevent
            fraudulent use, and cannot be switched off. Without these Cookies, the services You have
            asked for cannot be provided.
          </Paragraph>

          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            Cookie Consent Cookies
          </Typography>
          <Paragraph>
            <em>Type:</em> Persistent Cookie / Local Storage &nbsp;•&nbsp; <em>Administered by:</em>{" "}
            Us
            <br />
            These remember whether You have Accepted or Rejected cookies on the Website, and record
            the consent choice You have made, so that We can honor that choice on future visits and
            do not show the banner on every page load.
          </Paragraph>

          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            Functionality & Analytics Cookies
          </Typography>
          <Paragraph>
            <em>Type:</em> Persistent Cookies &nbsp;•&nbsp; <em>Administered by:</em> Us and trusted
            third parties (e.g. Google Analytics, Google Tag Manager)
            <br />
            These allow Us to remember choices You make when using the Website and to understand how
            visitors use the Website — such as pages visited and time spent — so We can measure and
            improve its performance. These are only set if You Accept cookies.
          </Paragraph>
        </Section>

        <Section heading="Your Choices">
          <Paragraph>
            When the cookie banner appears on Your first visit, You may:
          </Paragraph>
          <BulletList
            items={[
              "Accept — all cookies described above, including analytics and functionality cookies, are enabled.",
              "Reject — only strictly necessary cookies are used; analytics and functionality cookies are not set.",
              "Customize — You are taken to this Cookie Policy page to review the categories of cookies in detail before making a choice.",
            ]}
          />
          <Paragraph>
            You can also control or delete cookies through Your browser settings at any time. Most
            browsers allow You to refuse cookies, delete existing cookies, or be notified when a
            cookie is set. Please note that blocking or deleting cookies may affect the availability
            or functionality of some parts of the Website.
          </Paragraph>
        </Section>

        <Section heading="Third-Party Cookies">
          <Paragraph>
            In addition to Our own cookies, We may use various third-party cookies to report Website
            usage statistics, such as Google Analytics and Google Tag Manager. These third parties
            may use cookies in accordance with their own privacy and cookie policies, which We
            encourage You to review.
          </Paragraph>
        </Section>

        <Section heading="Changes to This Cookie Policy">
          <Paragraph>
            We may update this Cookie Policy from time to time to reflect changes in the cookies We
            use or for other operational, legal or regulatory reasons. Please revisit this page
            periodically to stay informed. The "Last updated" date at the top of this page shows
            when this Cookie Policy was last revised.
          </Paragraph>
        </Section>

        <Section heading="Contact Us">
          <Paragraph>If You have any questions about Our use of cookies, You can contact Us:</Paragraph>
          <BulletList
            items={[
              "By email: adgrohairdgl@gmail.com",
              "By phone: +91 082701 56789",
            ]}
          />
        </Section>
      </LegalLayout>

      <Footer />
    </div>
  );
}
